import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../Vender/css/TravelTheme.css";

const TravelThemes = ({ theme }) => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const themes = [
    {
      id: 1,
      title: "Heritage",
      description: "Explore the rich heritage and historical sites of India.",
      image: "/assets/images/h1.jpg",
      link: "/heritage",
      accent: "#D4A574",
    },
    {
      id: 2,
      title: "Beaches",
      description: "Relax on the pristine beaches and coastal destinations.",
      image: "/assets/images/b1.jpg",
      link: "/beaches",
      accent: "#7EC8E3",
    },
    {
      id: 3,
      title: "Mountain",
      description: "Adventure in the majestic mountains and hill stations.",
      image: "/assets/images/banner-img1-mountain.jpg",
      link: "/mountain",
      accent: "#98D8AA",
    },
    {
      id: 4,
      title: "Riverside",
      description: "Enjoy serene riverside retreats and backwater experiences.",
      image: "/assets/images/riverside.jpg",
      link: "/riverside",
      accent: "#B4E4FF",
    },
    {
      id: 5,
      title: "Wildlife",
      description: "Discover wildlife sanctuaries and national parks.",
      image: "/assets/images/wildlife.jpg",
      link: "/wildlife",
      accent: "#C3B091",
    },
  ];

  return (
    <div id="travel-theme-luxury">
      {/* Elegant Hero */}
      <header className="luxury-hero">
        <div
          className="hero-bg"
          style={{ backgroundImage: "url(/assets/images/travel.jpg)" }}
        ></div>
        <div className="hero-grain"></div>
        <div className="hero-vignette"></div>

        {/* Decorative Elements */}
        <div className="deco-line deco-line-1"></div>
        <div className="deco-line deco-line-2"></div>
        <div className="deco-circle"></div>

        <div className="hero-inner">
          {/* Breadcrumb */}
          <nav className="luxury-breadcrumb">
            <Link to="/" className="bc-link">
              <span>Home</span>
            </Link>
            <span className="bc-separator">—</span>
            <span className="bc-current">Travel Themes</span>
          </nav>

          {/* Hero Content */}
          <div className="hero-content-wrapper">
            <div className="hero-left">
              <span className="hero-eyebrow">— Curated Experiences</span>
              <h1 className="hero-headline">
                <span className="line">Discover</span>
                <span className="line">Your Perfect</span>
                <span className="line accent">Escape</span>
              </h1>
            </div>
            <div className="hero-right">
              <p className="hero-desc">
                Welcome to the Travel Theme page. Here you can explore various
                travel themes and ideas.
              </p>
              <div className="hero-cta">
                <a href="#themes" className="scroll-btn">
                  <span className="btn-text">Explore Themes</span>
                  <span className="btn-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    >
                      <path d="M12 5v14M5 12l7 7 7-7" />
                    </svg>
                  </span>
                </a>
              </div>
            </div>
          </div>

          {/* Floating Badge */}
          <div className="floating-badge">
            <span className="badge-number">5</span>
            <span className="badge-text">
              Unique
              <br />
              Themes
            </span>
          </div>
        </div>
      </header>

      {/* Themes Section */}
      <section id="themes" className="themes-showcase">
        <div className="section-intro">
          <div className="intro-left">
            <span className="intro-label">Our Collection</span>
            <h2 className="intro-title">Travel Themes</h2>
          </div>
          <div className="intro-right">
            <p>
              Each theme offers a unique perspective on travel, carefully
              curated to match your wanderlust.
            </p>
          </div>
        </div>

        {/* Theme Cards - Staggered Layout */}
        <div className="themes-stagger">
          {themes.map((item, index) => (
            <article
              key={item.id}
              className={`theme-item ${hoveredCard === item.id ? "is-active" : ""} ${hoveredCard && hoveredCard !== item.id ? "is-inactive" : ""}`}
              onMouseEnter={() => setHoveredCard(item.id)}
              onMouseLeave={() => setHoveredCard(null)}
              style={{ "--accent": item.accent }}
            >
              <Link to={item.link} className="theme-link">
                <div className="theme-visual">
                  <div className="visual-frame">
                    <img src={item.image} alt={item.title} />
                    <div className="visual-overlay"></div>
                  </div>
                  <div className="visual-accent"></div>
                </div>

                <div className="theme-info">
                  <div className="info-top">
                    <span className="theme-index">0{index + 1}</span>
                    <span className="theme-line"></span>
                  </div>
                  <h3 className="theme-name">{item.title}</h3>
                  <p className="theme-desc">{item.description}</p>
                  <div className="theme-action">
                    <span className="action-text">Explore</span>
                    <span className="action-arrow">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                      >
                        <path d="M5 12h14M12 5l7 7-7 7" />
                      </svg>
                    </span>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </section>

      {/* Elegant Divider */}
      <div className="elegant-divider">
        <span className="divider-line"></span>
        <span className="divider-icon">✦</span>
        <span className="divider-line"></span>
      </div>

      {/* Bottom CTA */}
      <section className="luxury-cta">
        <div className="cta-wrapper">
          <div className="cta-bg-text">EXPLORE</div>
          <div className="cta-content">
            <span className="cta-label">Ready for Adventure?</span>
            <h2 className="cta-title">
              Let's Plan Your
              <br />
              Dream Vacation
            </h2>
            <Link to="/contact" className="cta-btn">
              <span className="btn-bg"></span>
              <span className="btn-content">
                <span>Start Planning</span>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TravelThemes;
